module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00677.85f7eaa5.jpg";